<template>
  <div>
    <PersonalAreaNavBar
      :title="$t('personalArea.personalInfo')"
      backurl="personal-area-mainmenu"
    />
    <PersonalAreaNoInternet />
    <div class="pam-content lang-dir">
      <div
        style="padding: 0px 15px"
        :style="{ 'padding-top': $store.state.hasInternet ? '15px' : '0px' }"
      >
        <div class="gray-box">
          <PersonalAreaMenuLineTitle
            :msg="$t('personalArea.updateInfoMsgs.clientInfo')"
          />
          <PersonalAreaItemInfo
            :rtitle="$t('personalArea.updateInfoMsgs.clientNumber')"
            >{{ $store.state.user.stickerId }}</PersonalAreaItemInfo
          >
          <PersonalAreaItemInfo
            :rtitle="$t('personalArea.updateInfoMsgs.version')"
            :ltitle="$t('personalArea.updateInfoMsgs.subVersion')"
            :linfo="true"
            ><span>{{ licenseInfo.otzarVer }}</span
            ><template v-slot:lcontent
              ><span>{{
                String(parseFloat(licenseInfo.updatesVer).toFixed(5)).padEnd(
                  5,
                  "0"
                )
              }}</span></template
            ></PersonalAreaItemInfo
          >
          <PersonalAreaItemInfo :rtitle="$t('myLicense.edition')">{{
            mainEditionDesc
          }}</PersonalAreaItemInfo>
          <PersonalAreaItemInfo
            v-if="licenseInfo.Network"
            :rtitle="$t('personalArea.updateInfoMsgs.netStationOtzar')"
            ><span>{{
              licenseInfo.networkStations
            }}</span></PersonalAreaItemInfo
          >
          <PersonalAreaItemInfo
            :hideborder="true"
            v-if="licenseInfo.MefNetwork"
            :rtitle="$t('personalArea.updateInfoMsgs.netStationMefo')"
            ><span>{{ licenseInfo.MefStation }}</span></PersonalAreaItemInfo
          >
        </div>

        <div class="spacer"></div>
        <div class="gray-box">
          <PersonalAreaMenuLineTitle
            :msg="$t('personalArea.updateInfoMsgs.HardwareInfo')"
          />
          <!-- <PersonalAreaItemInfo rtitle="סוג דיסק"
            >דיסק קשיח חיצוני</PersonalAreaItemInfo
          > -->
          <PersonalAreaDiskInfo />
          <!-- <PersonalAreaItemInfo rtitle="יצרן">סאנדיסק</PersonalAreaItemInfo> -->
          <PersonalAreaItemInfo
            :rtitle="$t('personalArea.updateInfoMsgs.SerialNumber')"
            >{{ licenseInfo.serialNumber }}</PersonalAreaItemInfo
          >
          <!-- <PersonalAreaItemInfo rtitle="תוקף אחריות"
            >02.03.2024</PersonalAreaItemInfo
          > -->
        </div>
        <div class="spacer"></div>
        <!-- <div class="gray-box">
          <PersonalAreaMenuLineTitle msg="רשת" />
          <PersonalAreaItemInfo rtitle="מספר העמדות המקסימאלי"
            >10</PersonalAreaItemInfo
          >
          <PersonalAreaItemInfo rtitle="מספר העמדות המקסימאלי למפרשי האוצר"
            >5</PersonalAreaItemInfo
          >
          <PersonalAreaItemInfo rtitle="שם המחשב"
            ><span>EsterB5411</span>
            <template v-slot:mcontent>
              <div class="m-btn-pa" style="width: auto">
                <div class="btn btn-small" style="background: #a7610f">נתק</div>
              </div>
            </template>
          </PersonalAreaItemInfo>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
import PersonalAreaNavBar from "./PersonalAreaNavBar.vue";
import PersonalAreaNoInternet from "./PersonalAreaNoInternet.vue";
import PersonalAreaMenuLineTitle from "./PersonalAreaMenuLineTitle.vue";
import PersonalAreaItemInfo from "./PersonalAreaItemInfo.vue";
import { permissionsEnum } from "@/services/license.js";
import PersonalAreaDiskInfo from "./PersonalAreaDiskInfo.vue";
import { mapState } from "vuex";
export default {
  components: {
    PersonalAreaNoInternet,
    PersonalAreaNavBar,
    PersonalAreaMenuLineTitle,
    PersonalAreaDiskInfo,
    PersonalAreaItemInfo,
  },
  computed: {
    ...mapState("user", ["licenseInfo"]),
    mainEditionDesc() {
      if (this.licenseInfo.packages & 0x40000000) return "מלא";
      return "בני תורה";
    },
  },
};
</script>

<style lang="scss" scoped>
.gray-box {
  border-radius: 5px;
  background: #ebebeb;
  padding: 0px 15px;
}
.m-btn-pa {
  display: flex;
  align-items: center;
  width: auto;
}
.pam-content {
  padding-top: 15px;
}
.spacer {
  padding: 15px;
}
</style>
